import {Autocomplete, CircularProgress, Grid, TextField} from "@mui/material"
import React, {useEffect, useState} from "react"
import {useApiService} from "./InstitutionAutocompleteApi"


const getInitialState = (id, label) => {
    if (id && label) {
        return {
            id,
            label
        }
    }

    return null
}

const initialOptions = [
    {
        id: "new",
        label: "My Institution is not in the list below"
    }
]

export const InstitutionAutocomplete = ({
    name,
    authorizedUserName,
    authorizedUserId,
    authorizedUserIdError
}) => {
    const {search} = useApiService()

    const [institution, setInstitution] = useState(getInitialState(authorizedUserId, authorizedUserName))
    const [filter, setFilter] = useState("")
    const [options, setOptions] = useState(initialOptions)
    const [open, setOpen] = useState(false)
    const [error, setError] = useState(authorizedUserIdError)
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        let active = true

        if (!loading) {
            return undefined
        }

        search(filter, (institutions) => {
            if (active) {
                let newOptions = initialOptions

                if (institution && institution.id !== "new") {
                    newOptions = [...initialOptions, institution]
                }

                if (institutions) {
                    newOptions = [
                        ...newOptions,
                        ...institutions
                            .reduce((newOptions, newInstitution) => {
                                if (institution?.id !== newInstitution.id) {
                                    newOptions.push({
                                        id: newInstitution.id,
                                        label: newInstitution.authorized_user_name
                                    })
                                }

                                return newOptions
                            }, [])
                            .sort((a, b) => {
                                if (a.label.toLowerCase() < b.label.toLowerCase()) {
                                    return -1
                                }

                                if (a.label.toLowerCase() > b.label.toLowerCase()) {
                                    return 1
                                }

                                return 0
                            })
                    ]
                }

                setOptions(newOptions)
                setLoading(false)
            }
        })

        return () => {
            active = false
        }
    }, [loading, filter, institution, search])

    useEffect(() => {
        if (!open) {
            setOptions(initialOptions)
            setLoading(false)
        }
    }, [open])

    useEffect(() => {
        showNewUserForm(institution?.id === "new")
        showExistingUserForm(institution?.id && institution.id !== "new")
    }, [institution])


    const handleChange = (event, newValue) => {
        setInstitution(newValue)
        setError("")
    }

    const handleFilterChange = (event, newValue) => {
        setFilter(newValue)
        setLoading(institution?.label !== newValue)
    }

    const renderInput = (params) => {
        return <fieldset>
            <div class="form-group required">
                <label for="institution">Choose Institution</label>
                <div class="input select required">
                    <TextField
                        { ...params }
                        id="institution"
                        error={ !!error }
                        helperText={ error }
                        placeholder="Search institutions..."
                        variant="outlined"

                        InputProps={ {
                            ...params.InputProps,
                            style: {
                            fontSize: "14px",
                            lineHeight: 1.5,
                            color: "#555",
                            padding: "0 12px"
                        },
                            endAdornment: (
                                <React.Fragment>
                                    { loading
                                        && <CircularProgress
                                            color="inherit"
                                            size={ 20 }
                                        />}
                                    { params.InputProps.endAdornment }
                                </React.Fragment>
                            )
                        } }
                    />
                </div>
            </div>
        </fieldset>
    }

    const renderOption = (props, option) => {
        if (option.id === "new") {
            return <li { ...props }  style={{
                fontSize: "14px",
                lineHeight: 1.5,
                color: "#555",
                textTransform: "uppercase"
            }}>
                <strong>
                    { option.label }
                </strong>
            </li>
        }


        const match = option.label.toLowerCase()
            .indexOf(filter.toLowerCase())

        if (match >= 0) {
            return <li { ...props }  style={{
                fontSize: "14px",
                lineHeight: 1.5,
                color: "#555"
            }}>
                <Grid
                    container
                    alignItems="center"
                >
                    <Grid
                        item
                        sx={ {wordWrap: "break-word"} }
                    >
                  <span>
                     { option.label.substring(0, match) }
                  </span>
                        <span
                            style={ {
                                fontWeight: "bold"
                            } }
                        >
                     { option.label.substring(match, match + filter.length) }
                  </span>
                        <span>
                     { option.label.substring(match + filter.length) }
                  </span>
                    </Grid>
                </Grid>
            </li>
        }

        return <li { ...props }  style={{
            fontSize: "14px",
            lineHeight: 1.5,
            color: "#555"
        }}>
            { option.label }
        </li>
    }

    return <>
        <Autocomplete
            required
            open={ open }
            onOpen={ () => {
                setOpen(true)
                setLoading(true)
            } }
            onClose={ () => {
                setOpen(false)
                setLoading(false)
            } }
            loading={ loading }
            options={ options }
            value={ institution }
            onChange={ handleChange }
            inputValue={ filter }
            onInputChange={ handleFilterChange }
            renderInput={ renderInput }
            renderOption={ renderOption }

        />

        <input
            id="authorized-user-id"
            type="hidden"
            name={ name }
            value={ institution?.id ?? "" }
        />
    </>
}
